import { useCallback } from 'react';
import { useCurrentCourseDescriptor, useLeaveRevision } from '@pm2/course-revisions';
import { pm2SitemapStore, openMegaMenu } from '@pm2/sitemap-utils';
import { pm2ConfigStore } from '@pm2/store';

function useOpenMegaMenu(type) {
  const configStore = pm2ConfigStore.useStore();
  const sitemapStore = pm2SitemapStore.useStore();
  const courseDescriptor = useCurrentCourseDescriptor();
  const leaveRevision = useLeaveRevision(courseDescriptor);
  return useCallback(async (descriptor, options) => {
    const result = await leaveRevision();
    if (result === "cancel") {
      return;
    }
    {
      return await openMegaMenu(configStore, sitemapStore, descriptor, options);
    }
  }, [configStore, leaveRevision, sitemapStore, type]);
}

export { useOpenMegaMenu };
//# sourceMappingURL=hook.open-mega-menu.js.map
